export const DEFAULT_ITEM_INNER_HEIGHT = 70

export const DEFAULT_EMPTY_MSG = 'Nenhum resultado encontrado.'
export const DEFAULT_INITIAL_SEARCH_MSG = 'Digite para buscar o que está procurando.'
